// extracted by mini-css-extract-plugin
export default {"BlockGroup":"BlockGroup_BlockGroup__t6JD4"};